import React from 'react';
import  { FaHome } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import '../App.css'


function NotFound() {
  return <div className='hero'>

  <div className="text-center hero-content">

  <div className="max-w-lg">

   <h1 className=" color lg:text-8xl  text-5xl font-bold lg:mb-8 mb-5">
       Oops!
   </h1>

   <p className=" color lg:text-5xl text-3xl lg:mb-8 mb-2">404 - Page not found!</p>

   <Link className='btn back mt-5 ml-1 w-40 text-sm ease-out duration-300 hover:bg-purple-500 hover:scale-x-105 hover:scale-y-105 focus:outline-none border-purple-800' to="/">

     <FaHome className='mr-2' />
     
     Back To Home

   </Link>

  </div>
 

  </div>


  </div>;
}

 export default NotFound;
